import localStorage from 'store2';
import { AUTH_TOKEN_KEY } from '../constants';
export const decodeJwt = (jwt) => {
    if (!jwt) {
        return;
    }
    try {
        const base64Url = jwt.split('.')[1];
        const modifiedBase64Url = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const uriValue = window
            .atob(modifiedBase64Url)
            .split('')
            .map((character) => `%${`00${character.charCodeAt(0).toString(16)}`.slice(-2)}`)
            .join('');
        const payload = decodeURIComponent(uriValue);
        return JSON.parse(payload);
    }
    catch (_err) {
        /* eslint-disable no-console */
        console.error('failed to decode jwt');
        throw _err;
    }
};
export const getBACNumberFromJWT = () => {
    try {
        const auth = localStorage(AUTH_TOKEN_KEY);
        const token = auth === null || auth === void 0 ? void 0 : auth.access_token;
        const jwt = decodeJwt(token);
        if (!jwt) {
            return null;
        }
        const { bac_number: bacNumber } = jwt;
        return Array.isArray(bacNumber) ? bacNumber[0] : bacNumber;
    }
    catch (error) {
        return null;
    }
};
//# sourceMappingURL=jwt.js.map